import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { useState } from 'react';
// next
import { useRouter } from 'next/router';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Stack,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { FormProvider, RHFTextField } from '../../components/hook-form';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

export default function NegotiationRejectForm({ rejectDialog, closeRejectDialog, reloadOffer }) {
  const { enqueueSnackbar } = useSnackbar();
  const router = useRouter();
  const { oid } = router.query;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const OfferResponseSchema = Yup.object().shape({
    reason: Yup.string().required('사유를 입력해주세요')
  });

  const defaultValues = {
    reason: '',
  };

  const reasonPlaceholder = `예. 나에게 맞지 않는 업무입니다. / 업무가 너무 많습니다. / 컬처 핏이 맞지 않습니다.`;

  const methods = useForm({
    resolver: yupResolver(OfferResponseSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
  } = methods;

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await axios.post(`api/crews/offers/${oid}/reject/`, {
        reason: data.reason,
      });
      enqueueSnackbar('제안을 거절하셨습니다');
      reloadOffer();
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      console.error(error);
    }
  };

  const cancel = async () => {
    reset();
    closeRejectDialog();
  }

  return (
      <Dialog
        open={rejectDialog}
        fullWidth
        maxWidth="xs"
      >
      <DialogTitle>계약을 거절하실 건가요?</DialogTitle>
      <DialogContent>
        <DialogContentText id="reject-dialog" sx={{ mb: 2 }}>
          이유를 알려주시면 다음 매칭에 참고하겠습니다.
        </DialogContentText>
        <FormProvider methods={methods}>
          <RHFTextField
            name="reason"
            label="거절 사유"
            multiline
            minRows={3}
            placeholder={reasonPlaceholder}
          />
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2}>
          <LoadingButton
            sx={{ px: 3 }}
            onClick={cancel}
            loading={isSubmitting}
          >
            취소하기
          </LoadingButton>
          <LoadingButton
            sx={{ px: 3 }}
            onClick={handleSubmit(onSubmit)}
            variant="contained"
            loading={isSubmitting}
          >
            거절하기
          </LoadingButton>
        </Stack>
      </DialogActions>
      </Dialog>
  );
}
